import { createAsyncThunk } from '@reduxjs/toolkit'
import { login } from 'feature/auth/api'
import { LoginParams } from 'feature/auth/types'
import { RootState } from 'store/types'
import { Severity, addNotification } from 'widget/Notifications'

import { AuthStatus, SmsStatus, authActions } from '../authSlice'

// авторизация пользователя
// подтверждения смс
export const doLogin = createAsyncThunk<
  void,
  LoginParams,
  { state: RootState }
>('auth/doLogin', (param, { dispatch }) => {
  dispatch(authActions.setAuthInfo({ isLoading: true }))
  login(param)
    .then(({ data }) => {
      window.ym?.(107075503, 'reachGoal', 'form_200')
      dispatch(authActions.setSmsInfo({ status: SmsStatus.readyForSend }))
      dispatch(
        authActions.setAuthInfo({
          status: data.registrationRequired
            ? AuthStatus.smsConfirmed
            : AuthStatus.registered,
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
        }),
      )
    })
    .catch(error => {
      if (error.response.data.isCodeCanBeEntered === false) {
        dispatch(
          authActions.setSmsInfo({
            status: SmsStatus.readyForSend,
          }),
        )
        const notice = {
          severity: Severity.error,
          text:
            error.response.data.message ||
            `Превышено максимальное количество попыток ввода кода.
          Попробуйте заново запросить код.`,
        }

        dispatch(addNotification(notice))
      }
      dispatch(authActions.setSmsInfo({ error: error.response.data.message }))
    })
    .finally(() => {
      dispatch(authActions.setAuthInfo({ isLoading: false }))
    })
})
